import { render, staticRenderFns } from "./TabulatorComponent.vue?vue&type=template&id=4526ea38&"
import script from "./TabulatorComponent.vue?vue&type=script&lang=ts&"
export * from "./TabulatorComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports